import React, { useState } from 'react';
import './FranchiseInvestment.css';
import InfoRequestModal from './InfoRequestModal.tsx';

const FranchiseInvestment: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <section className="franchise-investment">
      <div className="franchise-investment__content">
        <h2 className="franchise-investment__title">INVESTMENT &amp; FEES</h2>
        <div className="franchise-investment__divider" />

        <div className="franchise-investment__grid">
          <div className="franchise-investment__summary">
            <div className="franchise-investment__summary-text-container">
              <p className="franchise-investment__summary-text">
                This is a summary of estimated investment and franchise fees.
              </p>
              <p className="franchise-investment__summary-text">
                Full breakdown available upon request.
              </p>
            </div>
            <div className="franchise-investment__button">
              <button
                className="franchise-investment__cta-button"
                onClick={handleOpenModal}
              >
                REQUEST INFORMATION
              </button>
            </div>
          </div>

          <div className="franchise-investment__fees">
            <div className="franchise-investment__fee-row">
              <span className="franchise-investment__fee-label">FRANCHISE FEE</span>
              <span className="franchise-investment__fee-value">$40,000</span>
            </div>
            <div className="franchise-investment__fee-row">
              <span className="franchise-investment__fee-label">INVESTMENT RANGE</span>
              <span className="franchise-investment__fee-value">$1,158,530 to $2,398,530</span>
            </div>
            <div className="franchise-investment__fee-row">
              <span className="franchise-investment__fee-label">LIQUID CAPITAL REQUIREMENT</span>
              <span className="franchise-investment__fee-value">$500,000</span>
            </div>
          </div>
        </div>
      </div>

      <InfoRequestModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </section>
  );
};

export default FranchiseInvestment;
